import { createFileRoute, Link } from "@tanstack/react-router";
import { Button, Flex, Result } from "antd";
import { useOrgSlug } from "@/common/artemis-operations/organization";

export const Route = createFileRoute("/_authenticated/billing/$outcome")({
	component: BillingCheckoutResult,
});

/**
 * Where Stripe Checkout sends the browser back: `/billing/success?session_id=…` after payment,
 * `/billing/cancel` when the customer backs out. A bare full-page route (see `_authenticated.tsx`),
 * outside the app shell. Display only — granting access happens off the Stripe webhook, never off this page.
 */
function BillingCheckoutResult() {
	const ok = Route.useParams().outcome === "success";
	const orgSlug = useOrgSlug();

	const action = orgSlug ? (
		<Link to="/$orgSlug/admin/billing" params={{ orgSlug }}>
			<Button type="primary" size="large">
				Back to billing
			</Button>
		</Link>
	) : (
		<Link to="/home">
			<Button type="primary" size="large">
				Continue to StratoNext
			</Button>
		</Link>
	);

	return (
		<Flex align="center" justify="center" style={{ minHeight: "100vh" }}>
			<Result
				status={ok ? "success" : "info"}
				title={ok ? "Subscription started" : "Checkout canceled"}
				subTitle={
					ok
						? "Your payment went through. Your environments are available as soon as Stripe confirms it, usually within seconds."
						: "No payment was taken. You can upgrade again any time from Billing."
				}
				extra={action}
				style={{ maxWidth: 560 }}
			/>
		</Flex>
	);
}
